import React from "react";
import classNames from "classnames";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Container,
} from "reactstrap";

function AdminNavbar(props) {
  const [color, setcolor] = React.useState("navbar-transparent");

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });

  const updateColor = () => {
    if (window.innerWidth < 993) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };

  return (
    <>
      <Navbar className={classNames("navbar-absolute", "cockpit-navbar", color)} expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            {/* Mobile hamburger only */}
            <div
              className={classNames("navbar-toggle d-inline d-lg-none", {
                toggled: props.sidebarOpened,
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="#" onClick={(e) => e.preventDefault()}>
              {props.brandText}
            </NavbarBrand>
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
